var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161,
    height: 152,
    viewBox: "0 0 161 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vspuvwqklc",
    width: "125%",
    height: "700%",
    x: "-12.5%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.24
  })), /*#__PURE__*/React.createElement("path", {
    id: "xj4rz4lhua",
    d: "M0 0L92 0 92 75 0 75z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-103 -201) translate(118 201)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#6D5990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 70,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2xwdtgucpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xj4rz4lhua"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9393EE",
    d: "M26.479 25.337V13.85c0-7.133-5.323-13.36-12.36-13.82C6.407-.476 0 5.699 0 13.39v16.588h.037C.827 54.976 21.095 75 45.999 75 71.404 75 92 54.168 92 28.47H29.575c-1.71 0-3.096-1.404-3.096-3.133",
    mask: "url(#2xwdtgucpb)"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#7A6130",
    transform: "translate(19 138)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.539,
    style: {
      mixBlendMode: "soft-light"
    },
    cx: 46.44,
    cy: 3.24,
    rx: 46.44,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.269,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 46.44,
    cy: 4.32,
    filter: "url(#vspuvwqklc)",
    rx: 38.88,
    ry: 1.62
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 11,
    x: 56,
    y: 14,
    fill: "#E2C2EF",
    rx: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBudget);
export default __webpack_public_path__ + "static/media/emptyBudget.1322a5fc2e5937cceef419073333d01e.svg";
export { ForwardRef as ReactComponent };